import { Injectable } from '@angular/core';
import { Group } from 'core/index';
import { Widget } from '@widgets/widget';
import {
  StudentsStatusWidget,
  SurveysWidget,
  StudentsProgressWidget,
  BestCommentsWidget,
  StudentsWidget,
  AutoevaluationWidget
} from '../group-dashboard-widgets';

@Injectable()
export class GroupDashboardWidgetsService {
  constructor() {}

  getWidgets(group: Group, role: any): Widget[] {
    const widgets = [];

    widgets.push(StudentsStatusWidget(group, role, 0));
    widgets.push(StudentsProgressWidget(group, role, 0));
    widgets.push(AutoevaluationWidget(group, role, 0));
    widgets.push(SurveysWidget(group, role, 0));
    widgets.push(BestCommentsWidget(group, role, 0));
    widgets.push(StudentsWidget(group, role, 0));

    switch (role.name) {
      case 'dachAdmin':
        widgets.splice(3, 2);
    }

    return widgets;
  }
}
